import React, { useState, useEffect, useRef } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useLocation, useNavigate } from 'react-router-dom';
import './NavBar-new.css?v=2';
import LogoAnimation from './SBK2.mp4'; // Ruta del video

const CustomNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  // Detectar clics fuera del menú
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  const handleLinkClick = (sectionId) => {
    if (location.pathname !== '/') {
      console.log(`Redirigiendo a la página principal para navegar a la sección: ${sectionId}`);
      navigate('/');

      const waitForElement = setInterval(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          console.log(`Desplazándose a la sección: ${sectionId}`);
          element.scrollIntoView({ behavior: 'smooth' });
          clearInterval(waitForElement); // Detén el intervalo una vez encontrado
        } else {
          console.log(`Esperando que la sección con ID ${sectionId} esté disponible en el DOM.`);
        }
      }, 100); // Verifica cada 100ms

      // Limita el tiempo de espera para evitar bucles infinitos
      setTimeout(() => {
        clearInterval(waitForElement);
        console.log(`Se agotó el tiempo esperando por la sección ${sectionId}.`);
      }, 5000); // 5 segundos como máximo
    } else {
      console.log(`Ya estás en la página principal. Desplazándose a la sección: ${sectionId}`);
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.log(`La sección con ID ${sectionId} no se encontró en el DOM.`);
      }
    }
  };

  const renderNavLink = (to, label, sectionId) => {
    if (location.pathname === '/') {
      // Si estás en la página principal, usa react-scroll para desplazarte
      return (
        <ScrollLink
          to={sectionId}
          smooth={true}
          duration={800}
          className="nav-item"
          onClick={handleMenuClose}
        >
          {label}
        </ScrollLink>
      );
    } else {
      // Si estás en otra página, redirige y luego desplázate
      return (
        <span
          className="nav-item"
          onClick={() => {
            handleMenuClose();
            handleLinkClick(sectionId);
          }}
        >
          {label}
        </span>
      );
    }
  };

  return (
    <header className="custom-navbar">
      <div className="nav-container" ref={navRef}>
        {/* Logo animado */}
        <a href="/" className="logo-container">
          <video
            src={LogoAnimation}
            autoPlay
            loop
            muted
            playsInline
            className="navbar-logo"
          />
        </a>

        {/* Botón del menú */}
        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
        >
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </button>

        {/* Links de navegación */}
        <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {renderNavLink('/', 'Inicio', 'hero-section')}
          {renderNavLink('/services', 'Nuestros Servicios', 'services-section')}
          {renderNavLink('/portfolio', 'Portafolio', 'portfolio-carousel')}
          {renderNavLink('/about', 'Nosotros', 'team-section')}
        </nav>

        {/* Botón Contáctanos */}
        <a href="/contact" className="contact-btn">
          Contáctanos
        </a>
      </div>
    </header>
  );
};

export default CustomNav;
